<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div id="pageItemList">
    <v-dialog
      v-model="value.show"
      @input="v => v || closeAction()"
      max-width="550px"
      :persistent="true"
    >
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t("finnishIssue") }}</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="finnishIssueForm">
            <v-container grid-list-sm>
              <v-layout wrap justify-space-between>
                <v-flex xs12>
                  <v-autocomplete
                    name="service_reports"
                    :label="$t('serviceReports')"
                    :items="serviceReports"
                    v-model="finnishIssue.service_reports"
                    :data-vv-as="$t('serviceReports')"
                    :error-messages="errors.collect('service_reports')"
                    v-validate="'required'"
                    item-text="rma"
                    item-value="id"
                    prepend-icon="build"
                    multiple
                    clearable
                    chips
                  >
                    <template v-slot:item="data">
                      <v-list-tile-content>
                        <v-list-tile-title
                          v-html="data.item.rma"
                        ></v-list-tile-title>
                        <v-list-tile-sub-title
                          v-html="data.item.component.name"
                        ></v-list-tile-sub-title>
                      </v-list-tile-content>
                      <v-list-tile-action v-if="data.item.issue !== null">
                        <v-icon color="grey">bug_report</v-icon>
                      </v-list-tile-action>
                    </template>
                  </v-autocomplete>
                </v-flex>
                <v-flex xs8>
                  <v-list dense light>
                    <v-list-tile v-for="file in files" :key="file.name">
                      <v-list-tile-content>
                        <v-list-tile-title
                          :class="file.error ? 'red--text' : 'text--primary'"
                          >{{ file.name }}</v-list-tile-title
                        >
                        <v-list-tile-sub-title
                          >{{ file.size | prettyBytes }} /
                          {{ file.progress }}%</v-list-tile-sub-title
                        >
                      </v-list-tile-content>

                      <!--<v-list-tile-action>-->
                      <!--<v-btn icon ripple @click="deleteFile(file)">-->
                      <!--<v-icon>-->
                      <!--clear-->
                      <!--</v-icon>-->
                      <!--</v-btn>-->
                      <!--</v-list-tile-action>-->
                    </v-list-tile>
                  </v-list>
                </v-flex>
                <v-flex xs4>
                  <v-layout align-end justify-end>
                    <upload-btn
                      small
                      color="primary"
                      :loading="addFileButtonLoading"
                      @file-update="addFile"
                      title="Dodaj plik"
                      noTitleUpdate
                    >
                    </upload-btn>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            flat
            @click.native="closeAction"
            :disabled="formDisabled"
            >{{ $t("close") }}</v-btn
          >
          <v-btn
            color="blue darken-1"
            flat
            @click.native="saveAction"
            :disabled="formDisabled"
            >{{ $t("finnishIssue") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { SHOW_SNACKBAR } from "@/store/actions.type";
import validationErrorsMixin from "@/mixins/validationErrors.mixin";
import { FINNISH_ISSUE } from "../../store/actions.type";
import UploadButton from "vuetify-upload-button";
import ApiService from "@/common/api.service";
import _ from "lodash";

export default {
  props: ["value"],
  data() {
    return {
      formDisabled: false,
      menu: false,
      LANG: process.env.VUE_APP_LANG,
      files: [],
      addFileButtonLoading: false
    };
  },
  components: {
    "upload-btn": UploadButton
  },
  computed: {
    ...mapGetters(["issue", "serviceReports", "finnishIssue"])
  },
  mixins: [validationErrorsMixin],
  methods: {
    saveAction() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.formDisabled = true;

          this.$store
            .dispatch(FINNISH_ISSUE, [this.value.issueId, this.finnishIssue])
            .then(() => {
              this.$store.dispatch(SHOW_SNACKBAR, {
                text: this.$t("savedSuccessfully", [this.$t("issue")]),
                color: "success"
              });

              this.closeAction();
              this.$emit("saved");
            })
            .catch(() => {
              this.formDisabled = false;
            });
        }
      });
    },
    closeAction() {
      this.$emit("input", {
        mode: this.value.mode,
        show: false
      });
      this.formDisabled = false;
      this.files = [];
      // we need wait for animation until is finished
      setTimeout(() => {
        this.$refs.finnishIssueForm.reset();
        this.$validator.reset();
      }, 100);
    },
    addFile(file) {
      this.formDisabled = true;
      this.addFileButtonLoading = true;
      let newFile = {
        name: file.name,
        size: file.size,
        type: file.type,
        progress: 0,
        error: false,
        url: ""
      };
      this.files.push(newFile);

      ApiService.uploadFile(
        "/issues/" + this.value.issueId + "/file",
        file,
        progressEvent => {
          newFile.progress = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
        }
      )
        .then(response => {
          this.addFileButtonLoading = false;
          this.formDisabled = false;

          newFile.url = response.data.download_url;
        })
        .catch(e => {
          newFile.error = true;
          this.formDisabled = false;

          throw e;
        });
    },
    deleteFile(file) {
      ApiService.delete(process.env.VUE_APP_API_HOST + file.url).then(() => {
        _.remove(this.files, e => {
          return e.url === file.url;
        });
      });
    }
  }
};
</script>

<style scoped></style>
